export default {
  lat: null,
  lng: null,
  allowed: null,
  loading: false,
}
